import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";


const baseURL = process.env.REACT_APP_API_URL;


const getAllRoles = async (data) => {
    const { page, perPage } = data;
    const response = await api.get(`${baseURL}/rol/listar?pagina=${page}&cantidadPagina=${perPage}`);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}
const createRol = async (data) => {
    const response = await api.post(`${baseURL}/rol/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('ROL CREADO', 'El rol se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const deleteRol = async (id) => {
    const response = await api.delete(`${baseURL}/rol/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('ROL ELIMINADO', 'El rol se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const updateRol = async (data) => {
    const response = await api.put(`${baseURL}/rol/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('ROL MODIFICADO', 'El rol se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const getSelectRols = async () => {
    const response = await api.get(`${baseURL}/rol/listar/select`);
    if (response.status === 200 || response.status === 201) {
        return response.data;
    } else {
        ToastChakra('ERROR', 'No se pudieron cargar los roles', 'error', 3000, 'bottom-right');
        return [];
    }
}



const rolService = {
    getAllRoles,
    createRol,
    deleteRol,
    updateRol,
    getSelectRols
}

export default rolService;